import { T } from 'gt-react';
import type { McpAccessDenialReason } from '@erp/rpc';

export function DenialMessage({ reason }: { reason: McpAccessDenialReason }) {
  switch (reason) {
    case 'missing_permission':
      return (
        <T context="Gently MCP consent: user needs the MCP server permission">
          Connecting AI agents requires the MCP server permission. Ask your
          administrator to grant access.
        </T>
      );
    case 'imitating':
      return (
        <T context="Gently MCP consent: admin is imitating another user">
          Stop imitating the other user before connecting an AI agent.
        </T>
      );
    case 'server_disabled':
      return (
        <T context="Gently MCP consent: the organization has not turned on MCP">
          Your organization hasn't turned on MCP. Ask an admin who can manage
          the MCP server settings.
        </T>
      );
  }
}
